






























import { Component, Prop, Mixins } from 'vue-property-decorator';
import FormFieldMixin from '@/mixins/registration/FormFieldMixin';
import RequiredFieldValidator from './validation/RequiredFieldValidator.vue';
import FileTypeValidator from './validation/FileTypeValidator.vue';

  @Component({
    inheritAttrs: false,
    components: { RequiredFieldValidator, FileTypeValidator }
  })
export default class FormFileInput extends Mixins(FormFieldMixin) {
    @Prop() readonly value!: File;
    @Prop() readonly fileType!: string;
    @Prop() readonly acceptFileTypes!: string;

    $refs!: {
      inputFileElement: HTMLFormElement;
    };

    get fileName (): string {
      if (this.value !== undefined && this.value !== null) {
        return this.value.name;
      }
      return '';
    }

    public openFileUpload (): void {
      this.$refs.inputFileElement.click();
    }

    public fileInput (event: any): void {
      this.$emit('input', event.target.files[0]);
    }
}
